import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Text, IconChevron } from "braid-design-system";
import { input, label, content, container } from "./AccordionToggle.css.mjs";
const AccordionToggle = ({
  id,
  label: label$1,
  className,
  isActive = false,
  isToggledOn,
  onToggleDropdown,
  onToggleInputRef
}) => {
  const trackingEvent = isToggledOn ? `${id}-closed` : `${id}-open`;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        id,
        type: "checkbox",
        className: input,
        checked: isToggledOn,
        onChange: onToggleDropdown,
        autoComplete: "off",
        ref: onToggleInputRef,
        "data-analytics": trackingEvent
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        component: "label",
        data: { automation: id },
        className: [container, className],
        htmlFor: id,
        children: /* @__PURE__ */ jsx(
          Box,
          {
            component: "span",
            display: "flex",
            alignItems: "center",
            justifyContent: "flexEnd",
            height: "touchable",
            className: content,
            children: /* @__PURE__ */ jsx(
              Box,
              {
                component: "span",
                className: label,
                userSelect: "none",
                "data-hj-masked": true,
                "data-testid": "toggle-label",
                children: /* @__PURE__ */ jsxs(
                  Text,
                  {
                    weight: isActive ? "strong" : "regular",
                    baseline: false,
                    maxLines: 1,
                    size: "small",
                    children: [
                      label$1,
                      " ",
                      /* @__PURE__ */ jsx(IconChevron, { direction: "down" })
                    ]
                  }
                )
              }
            )
          }
        )
      }
    )
  ] });
};
export {
  AccordionToggle
};
